import { z } from "zod/v4";
import { Form, FormProps } from "@/components/form";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import useFetch from "@/hooks/use-fetch";
import { checkBarrio } from "../api/check-barrio";
import { getAllCiudades } from "../../ciudades/api/get-all-ciudades";
import { getCiudad } from "../../ciudades/api/get-ciudad";
import { useEffect, useState } from "react";

export const editBarrioFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    codigo: z.string().nonempty("Este campo es requerido"),
    ciudadId: z.string().nonempty("Este campo es requerido"),
});

export default function EditBarrioForm({
    form,
    ...props
}: FormProps<z.infer<typeof editBarrioFormSchema>>) {
    const [defaultDocumento, setDefaultDocumento] = useState<string>("");
    const [currentDocumento, setCurrentDocumento] = useState<string>("");

    const updateCurrentDocumento = (value: string) => {
        setCurrentDocumento(value);
        if (value.trim()) fetch(value);
    }

    const { fetch, value, loading } = useFetch(async (value: string) => {
        if (value) return await checkBarrio(value);
        return undefined;
    }, { debounceMs: 500 });

    const barrioExists = (value !== null && value !== undefined) && (defaultDocumento !== currentDocumento); 
    
    useEffect(() => {
        setDefaultDocumento(form.options.defaultValues?.codigo ?? "");
    }, [])

    return <Form form={form} gap={3} {...props}>
        <Collapse in={barrioExists} sx={{ marginY: "-10px" }}>
            <Alert severity={"warning"}>
                Ya existe un barrio con ese código. No se pueden repetir códigos de barrio.
            </Alert>
        </Collapse>

        <Form.TextField name="nombre" label="Nombre" />
        <Form.TextField name="codigo" label="Código" onChange={e => updateCurrentDocumento(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.ModelComboBoxAsync
            name="ciudadId"
            label="Ciudad"
            get={getCiudad}
            getAll={getAllCiudades}
        />
        <Form.SubmitButton disabled={barrioExists}>Guardar</Form.SubmitButton>
    </Form>;   
}